import { Box, ButtonBase, Typography } from "@mui/material";

const GymCard = ({ gymName, gymAddress, gymDistance, gymIcon, onClick, selected, noPointer }) => {
  return (
    <ButtonBase
      style={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#1F222A",
        borderRadius: "12px",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 10px",
        cursor: !selected && !noPointer ? "pointer" : "default",
        gap: "10px",
        transition: "border 0.3s, box-shadow 0.3s",
        //border: selected ? "2px solid #FF6401" : "2px solid rgba(255, 255, 255, 0)",
        minHeight: "90px",
        maxWidth: "700px",
        width: "100%",
      }}
      onClick={onClick}
    >
      <Box
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          style={{
            backgroundColor: "#181A20",
            borderRadius: "8px",
            width: "80px",
            height: "80px",
            flexShrink: 0,
          }}
        >
          <img
            src={gymIcon}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            width: "100%",
          }}
        >
          <Typography
            style={{
              fontSize: "24px",
              fontFamily: "Urbanist",
              fontWeight: "bold",
              color: "rgba(255, 255, 255, 1)",
              lineHeight: "0.9",
              textAlign: "left",
            }}
          >
            {gymName}
          </Typography>
          <Typography
            style={{
              fontSize: "15px",
              fontFamily: "Urbanist",
              fontWeight: "500",
              color: "rgba(255, 255, 255, 1)",
              textAlign: "left",
              overflow: "hidden",
              textOverflow: "ellipsis",
              lineHeight: "1",
              width: "100%",
            }}
          >
            {gymAddress}
          </Typography>
        </Box>
      </Box>

      {gymDistance && (
        <Typography
          style={{
            fontSize: "20px",
            fontFamily: "Urbanist",
            fontWeight: "bold",
            color: "rgba(255, 255, 255, 1)",
            textAlign: "center",
            lineHeight: "1.2",
          }}
        >
          {gymDistance}
        </Typography>
      )}
    </ButtonBase>
  );
};

export default GymCard;
